import { subscribe } from '@/utils'

import { Params, Response } from '.'

const submit = async (params: Params): Promise<Response> => {
	try {
		const res = await subscribe.get<Response>('payment', { params })
		return res.data
	} catch (e) {
		throw e
	}
}

export const service = {
	submit
}
